var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{class:[_vm.loading ? 'loading' : ''],attrs:{"id":_vm.id,"disabled":_vm.disabled || _vm.loading,"size":_vm.size,"variant":"default"},on:{"click":_vm.onClick}},[(!_vm.loading)?_vm._t("default"):_c('loading',{staticClass:"w-100",attrs:{"size":_vm.size}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }